<template>
  <div>
    <div class="select-card" ref="selectCard">
      <div :class="selectPadding">
        <!-- 原班推荐图标 -->
        <div v-if="showRecommend" class="recommend-course-icon" />
        <div class="flex-center-start">
          <!-- 单选按钮 -->
          <div
            v-if="listType === 'common'"
            :class="[
              package_info.selectType === 2 ? 'select-icon' : 'unselect-icon',
            ]"
            @click.stop="selectPackageItem(package_info)"
          ></div>
          <div
            :class="[
              'content-wrap',
              {
                'max-content-wrap': listType === 'common' && !isCommonRecom,
              },
            ]"
            @click.stop="goReadSellPage"
          >
            <increaseInner
              v-if="isCommonRecom"
              :price="package_info.price || {}"
              :courseInfo="package_info"
              :selectType="package_info.selectType"
            />
            <template
              v-else-if="package_info.product_type !== 100 && !isSimpleProduct"
            >
              <!-- 大标题 -->
              <div
                :class="
                  package_info.selectType === 3
                    ? 'select-card-title-disabled'
                    : 'select-card-title'
                "
              >
                {{ package_info.name }}
              </div>
              <!-- 课程信息 课程标题，分类，老师，上课时间 -->
              <course-inner
                v-for="(pItem, pIndex) in product_list"
                :product_item="pItem"
                :teacherInfoList="teacherInfoList(pItem.extra_info)"
                :key="pIndex"
                :disabled="disabled"
              />
              <!-- 折叠按钮 -->
              <fold-button
                v-if="showFold"
                :isCollapse="isCollapse"
                :num="productCourseList.length - product_list.length"
                @changeCollapse="changeCollapse"
              ></fold-button>
              <!-- 商品套装 -->
              <product-inner
                v-if="$$(package_info.suit_list).length > 0"
                :pic_url="package_info.pic_url || []"
                :suit_list="package_info.suit_list || []"
                :disabled="disabled"
              ></product-inner>
            </template>
            <!-- 推荐课程内容 课程标题，分类，老师，上课时间-->
            <!-- 这里数据结构其实是个数组，但是目前的业务逻辑数组中只有一个数据，并且应该type为100 -->
            <recommend-inner
              v-else-if="
                !isSimpleProduct && $$(package_info.product_list).length > 0
              "
              :product_item="package_info.product_list[0]"
              :teacherInfoList="
                teacherInfoList(package_info.product_list[0].extra_info)
              "
              :disabled="disabled"
            ></recommend-inner>
            <simpleProduct
              v-else-if="isSimpleProduct"
              :disabled="disabled"
              :courseInfo="package_info"
            />
          </div>
        </div>
        <!-- 续报价格 -->
        <renewal-price
          v-if="!isCommonRecom"
          :halt_sale_date="package_info.halt_sale_desc || ''"
          :status="package_info.status || {}"
          :price="package_info.price || {}"
          :selectType="package_info.selectType"
        />
        <ConpackGift
          :packageInfo="package_info"
          :listType="listType"
          :cardType="cardType"
          :status="package_info.status || {}"
        />
        <!-- 去诊断，更换课程，换为本课 -->
        <change-course
          :status="package_info.status || {}"
          :package_info="package_info"
        ></change-course>
      </div>
      <!-- 首页的推荐商品列表，分割线在更换按钮的下面, 最后一个不展示分割线-->
      <div v-if="isCommonRecom && !isLast" class="divider-line"></div>
    </div>
    <van-popup
      v-model="showCanNotBuyPopup"
      round
      :close-on-click-overlay="false"
    >
      <div class="can-not-buy">
        <div class="msg" v-html="package_info.buy_limit_msg"></div>
        <div class="ok-btn" @click.stop="confirm">确认</div>
      </div>
    </van-popup>
    <detailPreviewPopup
      ref="detailPreviewPopup"
      :previewUrl="previewUrl"
      :name="package_info.name"
    />
  </div>
</template>

<script>
import courseInner from "./courseInner.vue";
import productInner from "./productInner.vue";
import foldButton from "./foldButton.vue";
import changeCourse from "./changeCourse.vue";
import recommendInner from "./recommendInner.vue";
import renewalPrice from "./renewalPrice.vue";
import { mapState } from "vuex";
import simpleProduct from "./simpleProduct.vue";
import { getCommonLog } from "../../changeCourse/utils/point";
import detailPreviewPopup from "./detailPreviewPopup.vue";
import increaseInner from "./increaseInner.vue";
import ConpackGift from "./ConpackGift.vue";
import { getRenewalData } from "@/common/script/log-helper";

export default {
  inject: {
    listType: {
      default: "",
    },
    cardType: {
      default: "",
    },
    isAddPriceBuy: {
      default: false,
    },
    recomNotAddPriceBuyLen: {
      default: 0,
    },
    getCurrentDiscount: {
      default: () => () => ({}),
    },
  },
  provide() {
    return {
      package_info_index: this.package_info_index, // 为了在跳转二级页的时候组装参数
      isSimpleProduct: this.isSimpleProduct, // 是否是纯实物商品
    };
  },
  props: {
    package_info_index: {
      // 记录当前顺序，为了在跳转二级页的时候组装参数
      // 顺便用来区分样式，当package_info中包含多个课程时，上边距缩小
      type: Number,
      default: 0,
    },
    // 这个showNotice只是为了样式上的区分，没有实际的业务作用
    // 并且由于多个package_info时冲突提示只有最外层，所以也只有第一个package_info顶部间距缩小
    showNotice: {
      type: Boolean,
      default: false,
    },
    package_info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 是否必须勾选
    must_check: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    renewalPrice,
    courseInner,
    productInner,
    foldButton,
    changeCourse,
    recommendInner,
    simpleProduct,
    detailPreviewPopup,
    increaseInner,
    ConpackGift,
  },
  computed: {
    ...mapState({
      stateContCourseData: (state) => state.contCourseData,
    }),
    isSimpleProduct() {
      // 是否是纯实物
      return (
        this.package_info?.product_type === 105 ||
        this.package_info?.product_type === 107
      );
    },
    isCommonRecom() {
      // 首页的推荐商品列表
      return (
        this.listType === "common" &&
        this.cardType === "recom" &&
        this.isAddPriceBuy &&
        this.recomNotAddPriceBuyLen === 0
      );
    },
    selectPadding() {
      if (this.isCommonRecom) {
        return "select-card-content-recom";
      }
      // 纯实物商品
      if (this.isSimpleProduct && this.listType === "change") {
        return "select-card-content-simple-product";
      }
      if (this.showNotice) {
        return "content-notice";
      } else if (this.package_info_index > 0) {
        return "select-card-content-small";
      } else {
        return "select-card-content";
      }
    },
    showRecommend() {
      const match_class_id = this.$store.state.originParams.match_class_id;
      // 说明原班推荐课程
      // match_class_id 等于 二级页返回的ilst中任意一个product_list extra_info. class_id
      const index = this.package_info.product_list.findIndex(
        (p) => +p?.extra_info?.class_id === +match_class_id
      );
      return this.listType === "change" && index > -1;
    },
    disabled() {
      return this.package_info.selectType === 3;
    },
    // 只包含课程的product_list
    productCourseList() {
      return (
        this.package_info?.product_list?.filter((item) => item.type === 100) ||
        []
      );
    },
  },
  data() {
    return {
      showCanNotBuyPopup: false,
      product_list: [],
      showFold: false,
      isCollapse: true,
      previewUrl: "",
    };
  },
  methods: {
    confirm() {
      this.showCanNotBuyPopup = false;
      if (this.package_info.learn_course_id) {
        const ele = document.querySelector(
          `#learn_course_id${this.package_info.learn_course_id}`
        );
        if (ele) {
          ele.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
      }
    },
    // 过滤教师信息，由于course-inner和recommend-inner的展示教师信息相同，所以抽离出来
    teacherInfoList(extra_info) {
      let teachers = [];
      const teacher_info = extra_info?.teacher_info || [];
      if (teacher_info.length > 2) {
        let firstTeacher = teacher_info[0];
        let lastTeacher = teacher_info[teacher_info.length - 1];
        if (firstTeacher.name.indexOf("等") < 0) {
          this.$set(firstTeacher, "name", `${firstTeacher?.name} 等`);
        }
        teachers = [firstTeacher, lastTeacher];
      } else {
        teachers = teacher_info;
      }
      return teachers;
    },
    // 设置课程展示列表
    setProductList() {
      if (this.productCourseList.length > 2) {
        this.showFold = true;
        this.isCollapse = true;
        this.product_list = this.productCourseList.slice(0, 2);
      } else {
        this.product_list = this.productCourseList || [];
      }
    },
    // 展开、折叠课程
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.product_list = this.productCourseList.slice(0, 2);
      } else {
        this.product_list = this.productCourseList;
      }
    },
    // 添加埋点
    addLog({ clickName, click_name, check_status, renewal_data }) {
      if (this.listType === "common") {
        this.$xesLogger.clickMsg({
          params: {
            click_id: `click_${click_name}`,
            click_name: `${
              this.cardType === "recom" ? "扩科" : "续联报"
            }${clickName}`,
            respos_type: this.cardType === "recom" ? 2 : 1,
            ...getCommonLog(this.package_info),
            discount: this.getCurrentDiscount(),
            ...(check_status && { check_status }),
            ...(renewal_data && { renewal_data }),
          },
        });
      }
    },
    // 单选某个package_info数据
    selectPackageItem(package_info) {
      console.log("cardType---", this.cardType);
      console.log("package_info---", package_info);
      this.addLog({
        clickName: "课程圈圈勾选点击",
        click_name: "hJoOeryL",
        check_status: package_info.selectType,
        renewal_data: getRenewalData(this.stateContCourseData, {
          tabListIndex: this.cardType === "raw" ? this.tab_list_index : -1,
          packageInfoIndex: this.package_info_index,
          nextSelectType: package_info.selectType === 2 ? 1 : 2,
        }),
      });
      if (package_info.selectType === 3) {
        if (package_info.buy_limit_msg) {
          this.showCanNotBuyPopup = true;
          return;
        }
        this.$toast({
          message: `${package_info.status.tips || "不可勾选"}`,
        });
      } else if (this.must_check) {
        this.$toast({
          message: "暂不支持取消",
        });
        return;
      } else {
        package_info.cardType = this.cardType;
        this.$EventBus.$emit("selectOne", package_info);
      }
    },
    goReadSellPage() {
      console.log("this.package_info ---type", this.package_info);
      if (this.listType === "common") {
        this.addLog({ clickName: "商品热区点击", click_name: "icXmro7q" });
      }
      const timer = setTimeout(
        () => {
          if (this.package_info.product_type === 100) {
            const item = this.package_info.product_list[0];
            // 用package_info.id跳转纯净版详情页
            this.previewUrl = `https://touch.xueersi.com/detail/mini/${item.id}/${item.extra_info.class_id}?hideBottomBar=1&hideBack=1`;
          } else if (this.isSimpleProduct) {
            // 跳转实物详情页
            const itemId =
              this.package_info?.product_list?.[0]?.extra_info?.item_id;
            if (itemId) {
              this.previewUrl = `https://touch.xueersi.com/product-sell?item_id=${itemId}&hideBottomBar=1&hideBack=1`;
            }
          } else {
            // 用任意extra_info.item_id跳转混合品纯净版
            const itemId =
              this.productCourseList?.[0]?.extra_info?.item_id ||
              this.package_info?.product_list?.[0]?.extra_info?.item_id; // 混合品可能存在配置了两个实物的情况(测试环境有这种情况出现了) 所以如果取不到课程的item_id，则取第一个实物的item_id
            this.previewUrl = `https://touch.xueersi.com/read-sell?item_id=${itemId}&hideBottomBar=1&hideBack=1`;
          }
          this.$refs.detailPreviewPopup.openDetail();
          clearTimeout(timer);
        },
        this.listType === "common" ? 300 : 0
      );
    },
    showLog() {
      try {
        // 资源位曝光埋点
        const options = {
          root: null, // 默认是浏览器视口
          rootMargin: "0px 0px -60px 0px", // 底部购买按钮高度为60px
          threshold: [0.5], // 当至少有50%的元素进入视口时触发回调
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // 元素进入视口
            if (entry.isIntersecting) {
              this.$xesLogger.loadMsg({
                show_id: "show_TZjDfEjI",
                show_name: `${
                  this.cardType === "raw" ? "续报" : "扩科"
                }资源位曝光`,
                respos_type: this.cardType === "raw" ? 1 : 2,
                ...getCommonLog(this.package_info),
              });
            }
          });
        }, options);
        observer.observe(this.$refs.selectCard);
      } catch (error) {
        console.log("埋点错误", error);
      }
    },
  },
  watch: {
    package_info: {
      immediate: true,
      handler: function () {
        this.setProductList();
      },
      deep: true,
    },
  },
  mounted() {
    this.setProductList();
    if (this.listType === "common") {
      this.showLog();
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.select-card {
  border-radius: 16px;
}
.select-card-content {
  position: relative;
  padding: 12px 12px 12px 8px;
  box-sizing: border-box;
}
.select-card-content-recom {
  padding: 0 12px 8px 8px;
}
.divider-line {
  height: 1px;
  width: calc(100% - 56px);
  background-color: #f3f3f4;
  margin: 8px 12px 8px 44px;
}
.content-notice {
  .select-card-content;
  padding-top: 8px;
}
.select-card-content-small {
  .select-card-content;
  padding-top: 12px;
}
.select-card-content-simple-product {
  .select-card-content;
  padding: 12px;
}
.notice-bar {
  .flex-center-start;
  background-color: #fff3e5;
  color: #ff8e00;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 500;
  height: 35px;
}
.select-card-title {
  .ellipsis-two;
  color: #333;
  text-align: justify;
  font-family: PingFang SC;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 8px;
}
.select-card-title-disabled {
  .select-card-title;
  color: #adadad;
}
.select-icon {
  margin-right: 8px;
  flex-shrink: 0;
  .connect-bg(28px,28px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/select-icon.png");
}
.unselect-icon {
  margin-right: 8px;
  flex-shrink: 0;
  .connect-bg(28px,28px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/unselect-icon.png");
}
.content-wrap {
  position: relative;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
}
.max-content-wrap {
  max-width: 285px;
}
.recommend-course-icon {
  .connect-bg(60px,14px,"https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/recommend-icon.png");
  position: absolute;
  top: 0;
  right: 0;
}
.can-not-buy {
  .column-center-start;
  width: 308px;
  padding: 24px;
  word-break: break-all;
  box-sizing: border-box;
  color: #333;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .msg {
    text-align: center;
  }
  .title {
    margin-bottom: 12px;
    color: #333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 17px;
    font-weight: 500;
  }
  .ok-btn {
    .flex-center-center;
    width: 244px;
    height: 40px;
    border-radius: 20px;
    color: #fff;
    font-family: PingFang SC;
    font-size: 15px;
    font-weight: 500;
    margin-top: 28px;
    background-color: rgba(249, 56, 52, 1);
  }
}
</style>
